import React, { useState, useEffect } from "react";
import Card from "../../shared/state-components/Card";
import axios from "axios";

const TransporterImages = (props) => {

    const [result, setResult] = useState([]);
    const images = result.map((id, i) => (
        <div key={i} className="quarter">
            <a href="#download-transporter-image" onClick={() => downloadTransImage(props.regID, id.RegistrationYear)}>
                {id.RegistrationYear}
            </a>
        </div>
    ));

    useEffect(() => {
        axios
            .get(`/api/v1/hwts/search/transImage?RegID=${props.regID}`)
            .then((res) => {
                setResult(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [props.regID]);

    const downloadTransImage = async(ID, year) => {
        await  axios({
            url: `/api/v1/hwts/search/download/transImage?RegID=${ID}&RegYear=${year}`,
            method: 'GET',
            responseType: 'blob', // important
            }).then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                let filename=`${ID}.zip`;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            }).catch((err) =>  {
                alert(err);
            });
    }

return(
    <Card
      cardType="default"
      cardHeader="placeholder"
      headerColor="#046B99"
      headerTextColor="#046B99"
      cardBody=""
      cardColor="white"
    >        
    <div className="facility-address-card">
        {images}
    </div>
    </Card>   
    );
    
};

export default TransporterImages;